import { inject, Injector } from '@angular/core';
import { UsersService } from '../../service/entity-services/users.service';
import { dateValueFormatter } from '../utils/format-date-cell';

let moment = require('moment');
const h2p = require('html2plaintext');

// Store the injector globally so formatters can access services
let globalInjector: Injector | null = null;

export function setContractColumnsInjector(injector: Injector): void {
  globalInjector = injector;
}



export let colCreationDate = {
                                colId: 'creationDate',
                                headerName: 'Created Date',
                                field: 'creationDate',
                                width: 50,
                                sortable: true,
                                filter: 'agDateColumnFilter',
                                filterParams:   {comparator: dateComparator},
                                comparator: dateComparator,
                                valueFormatter: dateValueFormatter
                            };


export let colContractLink =    {
                                    colId: 'linkToContract',
                                    headerName: 'Link To Contract',
                                    field: 'linkToContract',
                                    width: 100,
                                    sortable: true,
                                    cellRenderer: ({value}) => {
                                            const a = document.createElement('a');
                                            a.innerText = a.href = value;
                                            a.target = '_blank';
                                            // Prevent click from reaching AgGrid
                                            a.addEventListener('click', event => { event.stopPropagation() });
                                            return a;
                                        
                                    }
                                };

// export let colContractLink =    {
//                                     colId: 'linkToContract',
//                                     headerName: 'Link To Contract',
//                                     field: 'linkToContract',
//                                     width: 100,
//                                     sortable: true,
//                                     cellRenderer: ({value}) => {
//                                         if (value && environment.sso === false) {
//                                             const a = document.createElement('a');
//                                             a.innerText = a.href = value;
//                                             a.target = '_blank';
//                                             // Prevent click from reaching AgGrid
//                                             a.addEventListener('click', event => { event.stopPropagation() });
//                                             return a;
//                                         }
//                                     }
//                                 };

export let colContractNum = {colId: 'contractNum',
                             headerName: 'Number',
                             field: 'contractNum',
                             width: 100,
                             sortable: true};

export let colContractId = {
                                colId: 'contractId',
                                cellRenderer: 'agGroupCellRenderer',
                                headerName: 'Contract ID',
                                field: 'contractId',
                                width: 100,
                                sortable: true
                            };

export let colMainDocumentName = {
                                colId: 'mainDocumentName',
                                headerName: 'Main Document Name',
                                field: 'mainDocumentName',
                                width: 150,
                                sortable: true,
                                filter: true
                            };

export let colContractName = {
                                colId: 'nameOfContract',
                                headerName: 'Name',
                                field: 'nameOfContract',
                                width: 100,
                                sortable: true
                            };

export let colContractType =    {
                                    colId: 'contractType',
                                    headerName: 'Type',
                                    field: 'contractType',
                                    width: 100,
                                    sortable: true
                                };

export let colType =    {
                            colId: 'typeIndex',
                            headerName: 'Contract Type',
                            field: 'type',
                            width: 100,
                            sortable: true
                        };

export let colContractParty =   {
                                    colId: 'party',
                                    headerName: 'Party',
                                    field: 'directVendor.vendorData.name',
                                    width: 100,
                                    sortable: true,
                                    valueGetter: (params: any) => {
                                        const vendor = params.data?.directVendor;
                                        if (!vendor) return '';
                                        // Handle both wrapped (vendorData.name) and flat (name) structures
                                        return vendor?.vendorData?.name || vendor?.name || '';
                                    }
                                };

export let colContractPartyTIN =   {
                                        colId: 'partyTin',
                                        headerName: 'Party TIN',
                                        width: 100,
                                        sortable: true,
                                        valueGetter: (params: any) => {
                                            const vendor = params.data?.directVendor;
                                            if (!vendor) return '';
                                            return vendor?.vendorData?.tin || vendor?.tin || '';
                                        }
                                    };


export let colContractPartySpecialty =   {
                                            colId: 'partySpecialty',
                                            headerName: 'Party Specialty',
                                            width: 100,
                                            sortable: true,
                                            valueGetter: (params: any) => {
                                                const vendor = params.data?.directVendor;
                                                if (!vendor) return '';
                                                return vendor?.vendorData?.specialty || vendor?.specialty || '';
                                            }
                                        };

export let colContractPartyNpiNum =   {
                                        colId: 'partyNpiNum',
                                        headerName: 'Party NPI Num',
                                        width: 100,
                                        sortable: true,
                                        valueGetter: (params: any) => {
                                            const vendor = params.data?.directVendor;
                                            if (!vendor) return '';
                                            return vendor?.vendorData?.npiNum || vendor?.npiNum || '';
                                        }
                                    };

export let colContractPartyType =   {
                                        colId: 'partyType',
                                        headerName: 'Party Type',
                                        width: 100,
                                        sortable: true,
                                        valueGetter: (params: any) => {
                                            const vendor = params.data?.directVendor;
                                            if (!vendor) return '';
                                            return vendor?.vendorData?.partyType || vendor?.partyType || '';
                                        }
                                    };


export let colContractPartyCity =   {
                                        colId: 'partyCity',
                                        headerName: 'Party City',
                                        width: 100,
                                        sortable: true,
                                        valueGetter: (params: any) => {
                                            const vendor = params.data?.directVendor;
                                            if (!vendor) return '';
                                            return vendor?.vendorData?.city || vendor?.city || '';
                                        }
                                    };


export let colContractPartyState =   {
                                        colId: 'partyState',
                                        headerName: 'Party State',
                                        width: 100,
                                        sortable: true,
                                        valueGetter: (params: any) => {
                                            const vendor = params.data?.directVendor;
                                            if (!vendor) return '';
                                            return vendor?.vendorData?.state || vendor?.state || '';
                                        }
                                    };

export let colContractPartyZip =   {
                                        colId: 'partyZip',
                                        headerName: 'Party Zip',
                                        width: 100,
                                        sortable: true,
                                        valueGetter: (params: any) => {
                                            const vendor = params.data?.directVendor;
                                            if (!vendor) return '';
                                            return vendor?.vendorData?.zip || vendor?.zip || '';
                                        }
                                    };

export let colContractPartyCounty =   {
                                        colId: 'partyCounty',
                                        headerName: 'Party County',
                                        width: 100,
                                        sortable: true,
                                        valueGetter: (params: any) => {
                                            const vendor = params.data?.directVendor;
                                            if (!vendor) return '';
                                            return vendor?.vendorData?.county || vendor?.county || '';
                                        }
                                    };


export let colContractPartyCountry =   {
                                        colId: 'partyCountry',
                                        headerName: 'Party Country',
                                        width: 100,
                                        sortable: true,
                                        valueGetter: (params: any) => {
                                            const vendor = params.data?.directVendor;
                                            if (!vendor) return '';
                                            return vendor?.vendorData?.country || vendor?.country || '';
                                        }
                                    };


export let colContractPartyFromContractData =   {
                                                    colId: 'partyVendor',
                                                    headerName: 'Party/Vendor',
                                                    field: 'directVendor.vendorData.name',
                                                    width: 100,
                                                    sortable: true,
                                                    valueGetter: (params: any) => {
                                                        const vendor = params.data?.directVendor;
                                                        if (!vendor) return '';
                                                        // Handle both wrapped (vendorData.name) and flat (name) structures
                                                        return vendor?.vendorData?.name || vendor?.name || '';
                                                    }
                                                };

export let colContractStatus =  {
                                    colId: 'status',
                                    headerName: 'Status',
                                    field: 'status',
                                    width: 100,
                                    sortable: true
                                };

export let colContractExpirationDate =  {
                                            colId: 'expirationDate',
                                            headerName: 'Expiration Date',
                                            field: 'expirationDate',
                                            width: 100,
                                            sortable: true,
                                            filter: 'agDateColumnFilter',
                                            filterParams: {comparator: dateComparator},
                                            comparator: dateComparator,
                                            valueFormatter: dateValueFormatter,
                                            cellStyle: dateExpired
                                        };


// export let colContractExpirationDate =  {
//                                             colId: 'expirationDate',
//                                             headerName: 'Expiration Date',
//                                             field: 'expirationDate',
//                                             width: 100,
//                                             sortable: true,
//                                             filter: 'agDateColumnFilter',
//                                             filterParams: {comparator: dateComparator},
//                                             valueFormatter: dateValueFormatter,
//                                             cellStyle: dateExpired
//                                         };

export let colContractAnnualValue = {
                                        colId: 'annualValue',
                                        headerName: 'Annual Value',
                                        field: 'annualValue',
                                        width: 100,
                                        type: 'number',
                                        sortable: true
                                    };

export let colContractDepartment =  {
                                        colId: 'departments',
                                        headerName: 'Departments',
                                        field: 'departments',
                                        width: 100,
                                        sortable: true
                                    };

export let colLegalEntity = {
                                colId: 'legalEntities',
                                headerName: 'Legal Entity',
                                width: 100,
                                hide: false,
                                sortable: true,
                                valueGetter: (params: any) => {
                                    const legalEntities = params.data?.legalEntities;
                                    if (!legalEntities || !Array.isArray(legalEntities) || legalEntities.length === 0) {
                                        return '';
                                    }
                                    return legalEntities
                                        .map(le => le.legalEntityData?.legalEntityName || '')
                                        .filter(name => name)
                                        .join(', ');
                                }
                            };


export let colOtherParties =    {
                                    colId: 'otherParties',
                                    headerName: 'Other Parties',
                                    field: 'otherParties',
                                    width: 150,
                                    hide: false,
                                    sortable: true,
                                    valueGetter: (params: any) => {
                                        const otherParties = params.data?.otherParties;
                                        if (!otherParties || !Array.isArray(otherParties) || otherParties.length === 0) {
                                            return '';
                                        }
                                        // Extract party names from the array of party objects
                                        return otherParties
                                            .map(party => {
                                                // Handle both hydrated objects and string references
                                                if (party && typeof party === 'object') {
                                                    return party.vendorData?.name || party.name || '';
                                                }
                                                return ''; // If it's just a vendorNum string or null, we can't display it
                                            })
                                            .filter(name => name)
                                            .join(', ');
                                    }
                                };

export let colSubcontractors =  {
                                    colId: 'subcontractors',
                                    headerName: 'Sub-Contractors',
                                    field: 'subcontractors',
                                    width: 150,
                                    hide: false,
                                    sortable: true,
                                    valueGetter: (params: any) => {
                                        const subcontractors = params.data?.subcontractors;
                                        if (!subcontractors || !Array.isArray(subcontractors) || subcontractors.length === 0) {
                                            return '';
                                        }
                                        // Extract party names from the array of party objects
                                        return subcontractors
                                            .map(party => {
                                                // Handle both hydrated objects and string references
                                                if (party && typeof party === 'object') {
                                                    return party.vendorData?.name || party.name || '';
                                                }
                                                return ''; // If it's just a vendorNum string or null, we can't display it
                                            })
                                            .filter(name => name)
                                            .join(', ');
                                    }
                                };


export let colLegalEntityContractData = {
                                            colId: 'legalEntities',
                                            headerName: 'Legal Entity',
                                            field: 'legalEntities',
                                            width: 100,
                                            hide: false,
                                            sortable: true
                                        };

export let colContractMonthlyValue = {
                                        colId: 'monthlyValue',
                                        headerName: 'Monthly Value',
                                        field: 'monthlyValue',
                                        width: 100,
                                        type: 'number',
                                        filter: 'number',
                                        sortable: true
                                    };

export let colContractTotalValue =  {
                                        colId: 'totalValue',
                                        headerName: 'Total Value',
                                        field: 'totalValue',
                                        width: 100,
                                        type: 'number',
                                        filter: 'number',
                                        sortable: true
                                    };


export let colPartyContractCoordinator = {
                                            colId: 'partyContractCoordinator',
                                            headerName: 'Party Contract Coordinator',
                                            width: 100,
                                            sortable: true,
                                            valueGetter: (params) => {
                                                let person = params.data?.partyContractCoordinator;
                                                if (!person) return '';
                                                if (typeof person === 'string') return person;
                                                // Handle wrapped structure (contactData wrapper from API)
                                                if (person.contactData) {
                                                    person = person.contactData;
                                                }
                                                // Handle flat Person object (from PeopleService or extracted contactData)
                                                // Check friendlyName or fullName first (pre-computed)
                                                if (person.friendlyName) return person.friendlyName;
                                                if (person.fullName) return person.fullName;
                                                // Build from firstName/lastName
                                                if (person.firstName && person.lastName) {
                                                    return `${person.lastName}, ${person.firstName}`;
                                                }
                                                if (person.firstName) return person.firstName;
                                                if (person.lastName) return person.lastName;
                                                // Fallback to email or contactNum
                                                return person.email || person.contactNum || '';
                                            }
                                        };


export let colContractDescription = {
                                        colId: 'description',
                                        headerName: 'Description',
                                        field: 'description',
                                        width: 100,
                                        sortable: true
                                    };

export let colContractParentParty = {
                                        colId: 'parentParty',
                                        headerName: 'Parent Party',
                                        width: 100,
                                        sortable: true,
                                        valueGetter: (params: any) => {
                                            const parentParty = params.data?.parentParty;
                                            if (!parentParty) return '';
                                            // Handle wrapped structure (vendorData.name) or flat (name)
                                            return parentParty.vendorData?.name || parentParty.name || '';
                                        }
                                    };

export let colContractPrimaryResponsibleParty = {
                                                    colId: 'primaryOwner',
                                                    headerName: 'Primary Owner',
                                                    field: 'primaryOwner',
                                                    width: 100,
                                                    sortable: true,
                                                    valueGetter: (params) => {
                                                        const owner = params.data?.primaryOwner;
                                                        if (!owner) return '';
                                                        if (typeof owner === 'string') return owner;
                                                        if (owner.shortFriendlyName) return owner.shortFriendlyName;
                                                        // Check firstName/lastName at ROOT level first (hydrated user objects have these at root)
                                                        if (owner.firstName && owner.lastName) return `${owner.lastName}, ${owner.firstName}`;
                                                        if (owner.friendlyName) return owner.friendlyName;
                                                        if (owner.firstName) return owner.firstName;
                                                        if (owner.lastName) return owner.lastName;
                                                        return owner.userId || owner.email || owner.emailAddress || '';
                                                    },
                                                    valueFormatter: userFormatter
                                                };

export let colContractPrimaryOwnerFromContractData =    {
                                                            colId: 'primaryResponsibleParty',
                                                            headerName: 'Primary Owner',
                                                            field: 'primaryOwner',
                                                            width: 100,
                                                            sortable: true,
                                                            valueGetter: (params) => {
                                                                const owner = params.data?.primaryOwner;
                                                                if (!owner) return '';
                                                                if (typeof owner === 'string') return owner;
                                                                if (owner.shortFriendlyName) return owner.shortFriendlyName;
                                                                // Check firstName/lastName at ROOT level first (hydrated user objects have these at root)
                                                                if (owner.firstName && owner.lastName) return `${owner.lastName}, ${owner.firstName}`;
                                                                if (owner.friendlyName) return owner.friendlyName;
                                                                if (owner.firstName) return owner.firstName;
                                                                if (owner.lastName) return owner.lastName;
                                                                return owner.userId || owner.email || owner.emailAddress || '';
                                                            },
                                                            valueFormatter: userFormatter
                                                        };

export let colContractSecondaryResponsibleParty =   {
                                                        colId: 'secondaryOwner',
                                                        headerName: 'Secondary Owner',
                                                        field: 'secondaryOwner',
                                                        width: 100,
                                                        sortable: true,
                                                        valueGetter: (params) => {
                                                            const owner = params.data?.secondaryOwner;
                                                            if (!owner) return '';
                                                            if (typeof owner === 'string') return owner;
                                                            if (owner.shortFriendlyName) return owner.shortFriendlyName;
                                                            // Check firstName/lastName at ROOT level first (hydrated user objects have these at root)
                                                            if (owner.firstName && owner.lastName) return `${owner.lastName}, ${owner.firstName}`;
                                                            if (owner.friendlyName) return owner.friendlyName;
                                                            if (owner.firstName) return owner.firstName;
                                                            if (owner.lastName) return owner.lastName;
                                                            return owner.userId || owner.email || owner.emailAddress || '';
                                                        },
                                                        valueFormatter: userFormatter
                                                    };

export let colContractSecondaryOwnerFromContractData =   {
                                                            colId: 'secondaryResponsibleParty',
                                                            headerName: 'Secondary Owner',
                                                            field: 'secondaryResponsibleParty',
                                                            width: 100,
                                                            sortable: true,
                                                            valueGetter: (params) => {
                                                                const owner = params.data?.secondaryResponsibleParty;
                                                                if (!owner) return '';
                                                                if (typeof owner === 'string') return owner;
                                                                if (owner.shortFriendlyName) return owner.shortFriendlyName;
                                                                // Check firstName/lastName at ROOT level first (hydrated user objects have these at root)
                                                                if (owner.firstName && owner.lastName) return `${owner.lastName}, ${owner.firstName}`;
                                                                if (owner.friendlyName) return owner.friendlyName;
                                                                if (owner.firstName) return owner.firstName;
                                                                if (owner.lastName) return owner.lastName;
                                                                return owner.userId || owner.email || owner.emailAddress || '';
                                                            },
                                                            valueFormatter: userFormatter
                                                        };

export let colContractTertiaryResponsibleParty =    {
                                                        colId: 'tertiaryOwner',
                                                        headerName: 'Tertiary Owner',
                                                        field: 'tertiaryOwner',
                                                        width: 100, sortable: true,
                                                        valueGetter: (params) => {
                                                            const owner = params.data?.tertiaryOwner;
                                                            if (!owner) return '';
                                                            if (typeof owner === 'string') return owner;
                                                            if (owner.shortFriendlyName) return owner.shortFriendlyName;
                                                            // Check firstName/lastName at ROOT level first (hydrated user objects have these at root)
                                                            if (owner.firstName && owner.lastName) return `${owner.lastName}, ${owner.firstName}`;
                                                            if (owner.friendlyName) return owner.friendlyName;
                                                            if (owner.firstName) return owner.firstName;
                                                            if (owner.lastName) return owner.lastName;
                                                            return owner.userId || owner.email || owner.emailAddress || '';
                                                        },
                                                        valueFormatter: userFormatter
                                                    };

export let colContractTertiaryOwnerFromContractData =    {
                                                            colId: 'tertiaryResponsibleParty',
                                                            headerName: 'Tertiary Owner',
                                                            field: 'tertiaryResponsibleParty',
                                                            width: 100, sortable: true,
                                                            valueGetter: (params) => {
                                                                const owner = params.data?.tertiaryResponsibleParty;
                                                                if (!owner) return '';
                                                                if (typeof owner === 'string') return owner;
                                                                if (owner.shortFriendlyName) return owner.shortFriendlyName;
                                                                // Check firstName/lastName at ROOT level first (hydrated user objects have these at root)
                                                                if (owner.firstName && owner.lastName) return `${owner.lastName}, ${owner.firstName}`;
                                                                if (owner.friendlyName) return owner.friendlyName;
                                                                if (owner.firstName) return owner.firstName;
                                                                if (owner.lastName) return owner.lastName;
                                                                return owner.userId || owner.email || owner.emailAddress || '';
                                                            },
                                                            valueFormatter: userFormatter
                                                        };


export let colContractCoordinator =    {
                                            colId: 'yourContractCoordinator',
                                            headerName: 'Contract Coordinator',
                                            field: 'yourContractCoordinator',
                                            width: 100,
                                            sortable: true,
                                            valueGetter: (params) => {
                                                const entity = params.data?.yourContractCoordinator;
                                                if (!entity) return '';
                                                if (typeof entity === 'string') return entity;
                                                // Check for pre-computed shortFriendlyName first (from UsersService)
                                                if (entity.shortFriendlyName) return entity.shortFriendlyName;
                                                // Check firstName/lastName at ROOT level first (hydrated user objects have these at root)
                                                if (entity.firstName && entity.lastName) {
                                                    return `${entity.lastName}, ${entity.firstName}`;
                                                }
                                                // Handle Person object (flat structure)
                                                if (entity.friendlyName) return entity.friendlyName;
                                                if (entity.fullName) return entity.fullName;
                                                if (entity.firstName) return entity.firstName;
                                                if (entity.lastName) return entity.lastName;
                                                // Fallback to userId (email) or other identifiers
                                                return entity.userId || entity.email || entity.emailAddress || entity.contactNum || '';
                                            }
                                            // Note: No cellRenderer - valueGetter handles both User and Person objects
                                        };


export let colContractMasterContract =  {
                                            colId: 'masterContract',
                                            headerName: 'Master Contract ID',
                                            field: 'masterContract',
                                            width: 100,
                                            sortable: true
                                        };

export let colContractEffectiveDate =   {
                                            colId: 'effectiveDate',
                                            headerName: 'Effective Date',
                                            field: 'effectiveDate',
                                            width: 100,
                                            sortable: true,
                                            filter: 'agDateColumnFilter',
                                            filterParams: {comparator: dateComparator},
                                            comparator: dateComparator,
                                            valueFormatter: dateValueFormatter
                                        };

export let colContractExecutionDate =   {
                                            colId: 'executionDate',
                                            headerName: 'Execution Date',
                                            field: 'executionDate',
                                            width: 100,
                                            sortable: true,
                                            filter: 'agDateColumnFilter',
                                            filterParams: {comparator: dateComparator},
                                            comparator: dateComparator,
                                            valueFormatter: dateValueFormatter
                                        };

export let colContractLabel =   {
                                    colId: 'contractLabel',
                                    headerName: 'MSA/Subordinate',
                                    field: 'contractLabel',
                                    width: 100,
                                    sortable: true
                                };

export let colSites =   {
                            colId: 'sites',
                            headerName: 'Sites',
                            width: 100,
                            sortable: true,
                            valueGetter: (params: any) => {
                                const sites = params.data?.sites;
                                if (!sites || !Array.isArray(sites) || sites.length === 0) {
                                    return '';
                                }
                                return sites
                                    .map(site => {
                                        if (!site) return '';
                                        // Handle wrapped structure (siteData.name) or flat (name)
                                        return site.siteData?.name || site.name || '';
                                    })
                                    .filter(name => name)
                                    .join(', ');
                            }
                        };

export let colContractRenewalType = {
                                        colId: 'renewalType',
                                        headerName: 'Renewal Type',
                                        field: 'renewalType',
                                        width: 100,
                                        sortable: true
                                    };

export let colContractInitialTerm = {
                                        colId: 'initialTerm',
                                        headerName: 'Initial Term',
                                        field: 'initialTerm',
                                        width: 100,
                                        type: 'number',
                                        sortable: true
                                    };

export let colContractNumRenewals = {
                                        colId: 'numRenewals',
                                        headerName: 'Num Renewals',
                                        field: 'numRenewals',
                                        type: 'number',
                                        width: 100,
                                        sortable: true
                                    };

export let colContractRenewalCycle =    {
                                            colId: 'renewalCycleLimit',
                                            headerName: 'Renewal Cycle Limit',
                                            field: 'renewalCycleLimit',
                                            width: 100,
                                            type: 'number',
                                            sortable: true
                                        };

export let colContractRenewalTerm = {
                                        colId: 'renewalTerm',
                                        headerName: 'Renewal Term',
                                        field: 'renewalTerm',
                                        width: 100,
                                        type: 'number',
                                        sortable: true
                                    };

export let colContractPartiesSignatory = {
                                            colId: 'partiesSignatory',
                                            headerName: 'Parties Signatory',
                                            field: 'partiesSignatory',
                                            width: 100,
                                            sortable: true,
                                            valueGetter: (params) => {
                                                let person = params.data?.partiesSignatory;
                                                if (!person) return '';
                                                if (typeof person === 'string') return person;
                                                // Handle wrapped structure (contactData wrapper from API)
                                                if (person.contactData) {
                                                    person = person.contactData;
                                                }
                                                // Handle flat Person object (from PeopleService or extracted contactData)
                                                // Check friendlyName or fullName first (pre-computed)
                                                if (person.friendlyName) return person.friendlyName;
                                                if (person.fullName) return person.fullName;
                                                // Build from firstName/lastName
                                                if (person.firstName && person.lastName) {
                                                    return `${person.lastName}, ${person.firstName}`;
                                                }
                                                if (person.firstName) return person.firstName;
                                                if (person.lastName) return person.lastName;
                                                // Fallback to email or contactNum
                                                return person.email || person.contactNum || '';
                                            }
                                        };

export let colContractInternalSignatory =   {
                                                colId: 'internalSignatory',
                                                headerName: 'Internal Signatory',
                                                field: 'internalSignatory',
                                                width: 100,
                                                sortable: true,
                                                valueGetter: (params) => {
                                                    const entity = params.data?.internalSignatory;
                                                    if (!entity) return '';
                                                    if (typeof entity === 'string') return entity;
                                                    // Check for pre-computed shortFriendlyName first (from UsersService)
                                                    if (entity.shortFriendlyName) return entity.shortFriendlyName;
                                                    // Check firstName/lastName at ROOT level first (hydrated user objects have these at root)
                                                    if (entity.firstName && entity.lastName) {
                                                        return `${entity.lastName}, ${entity.firstName}`;
                                                    }
                                                    // Handle Person object (flat structure)
                                                    if (entity.friendlyName) return entity.friendlyName;
                                                    if (entity.fullName) return entity.fullName;
                                                    if (entity.firstName) return entity.firstName;
                                                    if (entity.lastName) return entity.lastName;
                                                    // Fallback to userId (email) or other identifiers
                                                    return entity.userId || entity.email || entity.emailAddress || entity.contactNum || '';
                                                }
                                                // Note: No cellRenderer - valueGetter handles both User and Person objects
                                            };

export let colContractClinicalOrAdmin = {
                                            colId: 'clinicalOrAdmin',
                                            headerName: 'Clinical/Admin',
                                            field: 'clinicalOrAdmin',
                                            width: 100,
                                            sortable: true
                                        };

export let colNoticePeriod =    {
                                            colId: 'noticePeriod',
                                            headerName: 'Notice Period',
                                            field: 'noticePeriod',
                                            width: 100,
                                            type: 'number',
                                            sortable: true
                                        };

export let colContractReviewPeriod =    {
                                            colId: 'reviewPeriod',
                                            headerName: 'Review Period',
                                            field: 'reviewPeriod',
                                            width: 100,
                                            type: 'number',
                                            sortable: true
                                        };

export let colContractLastReviewDate = {
                                            colId: 'lastReviewDate',
                                            headerName: 'Last Review Date',
                                            field: 'lastReviewDate',
                                            width: 100,
                                            sortable: true,
                                            filter: 'date',
                                            cellStyle: dateExpired,
                                            valueFormatter: dateValueFormatter
                                        };

export let colContractNextReviewDate =  {
                                            colId: 'nextReviewDate',
                                            headerName: 'Next Review Date',
                                            field: 'nextReviewDate',
                                            width: 100,
                                            sortable: true,
                                            filter: 'agDateColumnFilter',
                                            filterParams: {comparator: dateComparator},
                                            comparator: dateComparator,
                                            cellStyle: dateExpired,
                                            valueFormatter: dateValueFormatter
                                        };

// export let colContractBaaRequired = {colId: 'baaRequired',headerName: 'BAA Required', field: 'baaRequired',width: 100, sortable: true};

export let colContractPONumbers =   {
                                        colId: 'poNumber',
                                        headerName: 'PO Numbers',
                                        field: 'poNumber',
                                        width: 100,
                                        sortable: true
                                    };

export let colRiskCategory =    {
                                    colId: 'riskCategory',
                                    headerName: 'Risk Category',
                                    field: 'riskCategory',
                                    width: 100,
                                    sortable: true
                                };

export let colPaymentTerms =    {  
                                    colId: 'paymentTerms',
                                    headerName: 'Payment Terms',
                                    field: 'paymentTerms',
                                    width: 100,
                                    type: 'number',
                                    sortable: true
                                };

export let colPurchasePrice = {
                                colId: 'purchasePrice',
                                headerName: 'Purchase Price',
                                field: 'purchasePrice',
                                width: 100,
                                type: 'number',
                                sortable: true
                            };

export let colRiskScore =   {
                                colId: 'riskScore',
                                headerName: 'Risk Score',
                                field: 'riskScore',
                                width: 100,
                                sortable: true,
                                type: 'number',
                                valueFormatter: riskFormatter
                            };

export let colCoiRequired = {
                                colId: 'missingCoi',
                                headerName: 'Missing COI',
                                field: 'coiRequired',
                                width: 50,
                                sortable: true,
                                valueFormatter: missingCoiFormatter
                            };

export let colBaaRequired = {
                                colId: 'baaRequired',
                                headerName: 'Missing BAA',
                                field: 'baaRequired',
                                width: 50,
                                sortable: true,
                                valueFormatter: missingBaaFormatter
                            };

export let colMissingSignature = {
                                    colId: 'missingSignature',
                                    headerName: 'Missing Signature',
                                    field: 'missingSignature',
                                    width: 50,
                                    sortable: true,
                                    valueFormatter: missingSignatureFormatter
                                };

export let colPoRequired = {
                                colId: 'poRequired',
                                headerName: 'Missing PO',
                                field: 'poRequired',
                                width: 50,
                                sortable: true,
                                valueFormatter: missingPoFormatter
                            };

export let colEmbeddedBaa = {
                                colId: 'embeddedBaa',
                                headerName: 'Embedded BAA',
                                field: 'embeddedBaa',
                                width: 50,
                                sortable: true,
                                valueFormatter: embeddedBaaFormatter
                            };


export let colAutorenew = {
                                colId: 'autorenew',
                                headerName: 'Auto-Renew',
                                field: 'autorenew',
                                width: 25,
                                sortable: true,
                                valueFormatter: (params) => {
                                    return params.value ? 'Yes' : 'No';
                                  },
                            };


export let colRegulatory = {
                                colId: 'regulatory',
                                headerName: 'Regulatory',
                                field: 'regulatory',
                                width: 100,
                                sortable: true,
                                valueFormatter: (params) => {
                                    if (Array.isArray(params.value)) {
                                      return params.value.join(', '); // Join array elements with a comma and space
                                    } else if (params.value) {
                                      return params.value.toString(); // If not an array, convert to string (for robustness)
                                    } else {
                                      return ''; // Handle null or undefined values
                                    }
                                  },                                
                            };

export let colCostCenter = {
                                colId: 'costCenter',
                                headerName: 'Cost Center',
                                field: 'costCenter',
                                width: 50,
                                sortable: true,
                            };

export let colTermProvision = {
                                colId: 'termProvision',
                                headerName: 'Initial/Amended Term Provision',
                                field: 'termProvision',
                                width: 50,
                                sortable: true,
                                // Guarded: as a valueFormatter this also runs during
                                // export, where a throw would lose the whole workbook.
                                valueFormatter: ({value}) => value ? h2p(value) : ''
                            };

export let colDatabaseOrganization =    {
                                            colId: 'databaseOrg',
                                            headerName: 'Database Organization',
                                            field: 'databaseOrg',
                                            width: 50,
                                            sortable: true,
                                        };

export let colClientContractId =    {
                                            colId: 'clientContractId',
                                            headerName: 'Client Contract Num',
                                            field: 'clientContractId',
                                            width: 50,
                                            sortable: true,
                                        };


export let colFmvRenewalDate =    {
                                            colId: 'fmvRenewalDate',
                                            headerName: 'FMV Renewal Date',
                                            field: 'fmvRenewalDate',
                                            width: 50,
                                            sortable: true,
                                            filter: 'agDateColumnFilter',
                                            filterParams:   {comparator: fmvDateComparator},
                                            comparator: fmvDateComparator,
                                            valueFormatter: dateValueFormatter
                                        };

export let colFmvCompletedDate =    {
                                            colId: 'fmvCompletedDate',
                                            headerName: 'FMV Completed Date',
                                            field: 'fmvCompletedDate',
                                            width: 50,
                                            sortable: true,
                                            filter: 'agDateColumnFilter',
                                            filterParams:   {comparator: fmvDateComparator},
                                            comparator: fmvDateComparator,
                                            valueFormatter: dateValueFormatter
                                        };


export let allColumns = [
    colAutorenew,
    colRegulatory,
    colContractCoordinator,
    colFmvRenewalDate,
    colFmvCompletedDate,
    colCostCenter,
    colTermProvision,
    colDatabaseOrganization,
    colClientContractId,
    colContractId,
    colContractNum,
    colContractName,
    colMainDocumentName,
    colContractType,
    // colType,
    colContractParty,
    colContractPartyTIN,
    colContractPartySpecialty,
    colContractPartyNpiNum,
    colContractPartyType,
    colContractPartyCity,
    colContractPartyState,
    colContractPartyZip,
    colContractPartyCounty,
    colContractPartyCountry,
    colContractStatus,
    colContractExpirationDate,
    colContractAnnualValue,
    colContractDepartment,
    colLegalEntity,
    colContractMonthlyValue,
    // colContractPrimaryPerson,
    colContractLabel,
    colContractDescription,
    colSites,
    colContractTotalValue,
    colPartyContractCoordinator,
    colContractParentParty,
    colContractPrimaryResponsibleParty,
    colContractSecondaryResponsibleParty,
    colContractTertiaryResponsibleParty,
    colContractMasterContract,
    colContractEffectiveDate,
    colContractExecutionDate,
    // colContractVersion,
    colContractRenewalType,
    colContractInitialTerm,
    colContractNumRenewals,
    colContractRenewalCycle,
    colContractRenewalTerm,
    colContractPartiesSignatory,
    colContractInternalSignatory,
    colContractClinicalOrAdmin,
    colNoticePeriod,
    colContractReviewPeriod,
    colContractLastReviewDate,
    colContractNextReviewDate,
    // colContractBaaRequired,
    colContractPONumbers,
    colRiskCategory,
    colPaymentTerms,
    colPurchasePrice,
    colRiskScore,
    colCoiRequired,
    colBaaRequired,
    colMissingSignature,
    colPoRequired,
    colEmbeddedBaa,
    colCreationDate,
    colContractLink,
    colOtherParties,
    colSubcontractors
];



export let columnSelectList = [
    {
        value: colAutorenew,
        viewValue: colAutorenew.headerName
    },
    {
        value: colContractCoordinator,
        viewValue: colContractCoordinator.headerName
    },
    {
        value: colFmvCompletedDate,
        viewValue: colFmvCompletedDate.headerName
    },
    {
        value: colFmvRenewalDate,
        viewValue: colFmvRenewalDate.headerName
    },
    {
        value: colRegulatory,
        viewValue: colRegulatory.headerName
    },
    {
        value: colCostCenter,
        viewValue: colCostCenter.headerName
    },
    {
        value: colTermProvision,
        viewValue: colTermProvision.headerName
    },
    {
        value: colDatabaseOrganization,
        viewValue: colDatabaseOrganization.headerName
    },
    {
        value: colClientContractId,
        viewValue: colClientContractId.headerName
    },
    {
        value: colContractId,
        viewValue: colContractId.headerName
    },
    {
        value: colContractNum,
        viewValue: 'Contract Number'
    },
    {
        value: colMainDocumentName,
        viewValue: colMainDocumentName.headerName
    },
    {
        value: colContractName,
        viewValue: "Name"
    },
    {
        value: colContractType,
        colId: 'type',
        viewValue: colContractType.headerName
    },
    // {
    //     value: colType,
    //     colId: 'typeIndex',
    //     viewValue: colType.headerName
    // },
    {
        value: colContractParty,
        viewValue: "Party"
    },
    {
        value: colContractPartyTIN,
        viewValue: "Party TIN"
    },
    {
        value: colContractPartySpecialty,
        viewValue: "Party Specialty"
    },
    {
        value: colContractPartyNpiNum,
        viewValue: "Party NPI Num"
    },
    {
        value: colContractPartyType,
        viewValue: "Party Type"
    },
    {
        value: colContractPartyCity,
        viewValue: "Party City"
    },
    {
        value: colContractPartyState,
        viewValue: "Party State"
    },
    {
        value: colContractPartyZip,
        viewValue: "Party Zip"
    },
    {
        value: colContractPartyCounty,
        viewValue: "Party County"
    },
    {
        value: colContractPartyCountry,
        viewValue: "Party Country"
    },
    {
        value: colContractStatus,
        viewValue: "Status"
    },
    {
        value: colContractExpirationDate,
        viewValue: "Expiration Date"
    },
    {
        value: colContractAnnualValue,
        viewValue: "Annual Value"
    },
    {
        value: colContractDepartment,
        viewValue: "Department"
    },
    {
        value: colLegalEntity,
        viewValue: "Legal Entity"
    },
    {
        value: colContractDescription,
        viewValue: "Description"
    },
    {
        value: colContractParentParty,
        viewValue: "Parent Party"
    },
    {
        value: colContractPrimaryResponsibleParty,
        viewValue: "Primary Owner"
    },
    {
        value: colContractSecondaryResponsibleParty,
        viewValue: "Secondary Owner"
    },
    {
        value: colContractTertiaryResponsibleParty,
        viewValue: "Tertiary Owner"
    },
    {
        value: colContractMasterContract,
        viewValue: "Master Contract"
    },
    {
        value: colContractEffectiveDate,
        viewValue: "Effective Date"
    },
    {
        value: colContractExecutionDate,
        viewValue: "Execution Date"
    },
    {
        value: colContractLabel,
        viewValue: "MSA/Subordinate"
    },
    // {
    //     value: colContractVersion,
    //     viewValue: "Version"
    // },
    {
        value: colContractMonthlyValue,
        viewValue: "Monthly Value"
    },
    {
        value: colContractRenewalType,
        viewValue: "Renewal Type"
    },
    {
        value: colContractInitialTerm,
        viewValue: "Initial Term"
    },
    {
        value: colContractNumRenewals,
        viewValue: "Num Renewals"
    },
    {
        value: colContractRenewalCycle,
        viewValue: "Renewal Cycle"
    },
    {
        value: colContractRenewalTerm,
        viewValue: "Renewal Term"
    },
    {
        value: colContractPartiesSignatory,
        viewValue: "Parties Signatory"
    },
    {
        value: colContractInternalSignatory,
        viewValue: colContractInternalSignatory.headerName
    },
    {
        value: colSites,
        viewValue: colSites.headerName
    },
    {
        value: colContractClinicalOrAdmin,
        viewValue: colContractClinicalOrAdmin.headerName
    },
    {
        value: colNoticePeriod,
        viewValue: colNoticePeriod.headerName
    },
    {
        value: colContractReviewPeriod,
        viewValue: colContractReviewPeriod.headerName
    },
    {
        value: colContractLastReviewDate,
        viewValue: colContractLastReviewDate.headerName
    },
    {
        value: colContractNextReviewDate,
        viewValue: colContractNextReviewDate.headerName
    },
    // {
    //     value: colContractBaaRequired,
    //     viewValue: colContractBaaRequired.headerName
    // },
    {
        value: colContractPONumbers,
        viewValue: colContractPONumbers.headerName
    },
    {
        value: colContractTotalValue,
        viewValue: colContractTotalValue.headerName
    },
    {   
        value: colPartyContractCoordinator,
        viewValue: colPartyContractCoordinator.headerName
    },
    {
        value: colRiskCategory,
        viewValue: colRiskCategory.headerName
    },
    {
        value: colPaymentTerms,
        viewValue: colPaymentTerms.headerName
    },
    {
        value: colPurchasePrice,
        viewValue: colPurchasePrice.headerName
    },
    {
        value: colRiskScore,
        viewValue: colRiskScore.headerName
    },
    {
        value: colCoiRequired,
        viewValue: colCoiRequired.headerName
    },
    {
        value: colBaaRequired,
        viewValue: colBaaRequired.headerName
    },
    {
        value: colMissingSignature,
        viewValue: colMissingSignature.headerName
    },
    {
        value: colPoRequired,
        viewValue: colPoRequired.headerName
    },
    {
        value: colCreationDate,
        viewValue: colCreationDate.headerName
    },
    {
        value: colContractLink,
        viewValue: colContractLink.headerName
    },
    {
        value: colEmbeddedBaa,
        viewValue: colEmbeddedBaa.headerName
    },
    {
        value: colOtherParties,
        viewValue: colOtherParties.headerName
    },
    {
        value: colSubcontractors,
        viewValue: colSubcontractors.headerName
    }
];



function ArrayFilter(params) {

}


ArrayFilter.prototype.init = function(params) {
    this.valueGetter = params.valueGetter;
    this.filterText = null;
};

ArrayFilter.prototype.getGui = function() {
    return '<div />';
};


ArrayFilter.prototype.doesFilterPass = function(params) {
    // make sure each word passes separately, ie search for firstname, lastname
    let passed = true;
    let valueGetter = this.valueGetter;

    this.filterText.toLowerCase().split(', ').forEach(function(filterWord) {
        let value = valueGetter(params);

        if (value.toString().toLowerCase().indexOf(filterWord) < 0) {
            passed = false;
        }
    });

    return passed;
};


function numberSort(num1: string, num2: string) {

    if ((num1 != undefined) &&
        (num2 != undefined)) {
            // console.log('num1: ', num1.toString().replace(/[^\d.]/g, ''));
            let firstNumber = parseInt(num1.toString().replace(/[^\d.]/g, ''));
            let secondNumber = parseInt(num2.toString().replace(/[^\d.]/g, ''));

            if (firstNumber >= secondNumber) {
                return -1;
            } else {
                return 1;
            }
        }


    // if (date1AsMoment.isBefore(date2AsMoment)) {
    //     return -1;
    // } else {
    //     return 1;
    // }


  };



function fmvDateComparator(date1, date2) {

// '2022-06-08T00:00:00+00:00'

    // picking random date in past
    if (!date1 || date1 === ' ') {
        date1 = '2000-06-08T00:00:00+00:00';
    }

    // picking different random date in past
    if (!date2 || date2 === ' ') {
        date2 = '2001-06-08T00:00:00+00:00'
    }


    let date1AsMoment = moment(date1);
    let date2AsMoment = moment(date2);

    if (date1AsMoment.isValid() && date2AsMoment.isValid()) {

        if (date1AsMoment.isBefore(date2AsMoment)) {
            return 1;
        } else {
            return -1;
        }

    }





}





/**
 * Format user field for display in grid
 * Hydrated user objects have firstName/lastName at ROOT level (not inside userData)
 * Display format: "Last Name, First Name"
 */
export function userFormatter(params) {
    const user = params.value;

    if (!user) return '';

    // Handle string format (email) - look up user name from service
    if (typeof user === 'string') {
        if (globalInjector) {
            try {
                const usersService = globalInjector.get(UsersService);
                return usersService.getUserDisplayNameByEmail(user);
            } catch (error) {
                console.warn('Could not get UsersService in userFormatter:', error);
                return user;
            }
        }
        return user;
    }

    // For objects, check root-level fields first (hydrated user objects have these at root)
    if (typeof user === 'object') {
        if (user.shortFriendlyName) return user.shortFriendlyName;
        if (user.firstName && user.lastName) return `${user.lastName}, ${user.firstName}`;
        if (user.friendlyName) return user.friendlyName;
        if (user.firstName) return user.firstName;
        if (user.lastName) return user.lastName;
        return user.userId || user.email || '';
    }

    return '';
}

function dateComparator(date1, date2) {

    if (date1 === null && date2 === null) {
          return 0;
    }

    if (date1 === null || date1 === undefined || date1 === '' || !date1 ) {
        return -1;
    }

    if (date2 === null || date2 === undefined || date2 === '' || !date2 ) {
        return 1;
    }    

    let date1AsMoment = moment(date1);
    let date2AsMoment = moment(date2);
    // let date1AsMoment = moment(date1, ["MM-DD-YYYY", "M-D-YYYY", "MM/DD/YYYY"]);
    // let date2AsMoment = moment(date2, ["MM-DD-YYYY", "M/D/YYYY", "MM/DD/YYYY"]);

    if (date1AsMoment.isValid() && date2AsMoment.isValid()) {

        // console.log(date1);

        if (date1AsMoment.isBefore(date2AsMoment)) {
            return -1;
        } else {
            return 1;
        }

    } else {
        // BUGBUG:  I don't know what this case means.
        
        // console.log('******* something is not a date');
        // console.log(date1);
        // console.log(typeof date1);
        // console.log(date1.length);
        // console.log(date2);
        // console.log(typeof date2);
        return 0;
    }

}


function siteCellRenderer(params) {

    if (!params.value) return '';

    console.log('cell renderer: ', params);


    // if (typeof params.value != 'object') {
    //     console.log('cell renderer: ', params.value);
    // } else {
    //     console.log('object cell renderer: ', params);
    //     console.log('object value: ', params.value);
    // }

    let siteList = '';

    if ((params.value != undefined) &&
        (Array.isArray(params.value))) {
            params.value.forEach(element => {
                siteList = siteList + element.name + ' ';
            });
    } else {
        return params.value;
    }

    return 'foobar';
  }



function siteFormatter(params) {

    let siteList = '';

    if ((params.value != undefined) &&
        (Array.isArray(params.value))) {
            params.value.forEach(element => {
                siteList = siteList + element.name + ' ';
            });
    }
    return siteList;
}


function legalEntityFormatter(params) {

    let legalEntityList = [];

    if ((params.value) &&
        (Array.isArray(params.value))) {
            params.value.forEach(element => {
                legalEntityList = legalEntityList.concat(element.legalEntityName);
            });
    }

    return legalEntityList.toString();
    // return legalEntityList;
}





function dateExpired(param) {

    if (param.value != undefined) {
        let dateToEvaluate = moment(param.value);

        let daysPast = moment().diff(dateToEvaluate, 'days');
        // console.log('days past: ', daysPast);

        if (daysPast >= 0) {
        return {color: 'black', backgroundColor: 'red'};
        } else if (daysPast >= 180) {
        return {color: 'black', backgroundColor: 'yellow'};
        }
    }

}




function currencyFormatter(params) {

    let usdFormate = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
    });

    let valueNumber = null;

    if (params.value != undefined) {
        valueNumber = parseInt(params.value.toString().replace(/[^\d.]/g, ''));
    }


    if (usdFormate.format(params.value) == '$0' ||
        (usdFormate.format(params.value) == '$NaN')) {
      return '$0.00';
    } else {
      return usdFormate.format(valueNumber);
    }

  }


function riskFormatter(param) {

    // console.log('riskFormatter: ', param.data.riskScore);

    let scoreAsNumber = Number(param.data.riskScore);
    let scoreAsFloat = scoreAsNumber.toFixed(1);

    // console.log('scoreAsFloat: ', scoreAsFloat);

    if ((scoreAsFloat) &&
        (scoreAsFloat != 'NaN')) {
      return scoreAsFloat;
    } else {
      return '';
    }
  }


  function missingCoiFormatter(param) {

    if (param.data.coiRequired) {
        return 'Yes';
    } else {
        return 'No';
    }
  }


  function missingBaaFormatter(param) {

    if (param.data.baaRequired) {
        return 'Yes';
    } else {
        return 'No';
    }
  }


  function missingSignatureFormatter(param) {

    if (param.data.missingSignature) {
        return 'Yes';
    } else {
        return 'No';
    }
  }


  function missingPoFormatter(param) {

    if (param.data.poRequired) {
        return 'Yes';
    } else {
        return 'No';
    }
  }

  function embeddedBaaFormatter(param) {

    if (param.data.embeddedBaa) {
        return 'Yes';
    } else {
        return 'No';
    }
  }
